/* eslint-disable react/no-unescaped-entities */
import LegalLayout from "./LegalLayout";
import { COMPANY } from "./_company";

export default function Livraison() {
  return (
    <LegalLayout
      eyebrow="Boutique · Livraison"
      title="Livraison"
      lastUpdated={COMPANY.effectiveDate}
      intro="Nos épices, ustensiles et livres voyagent avec soin. Voici comment ils arrivent chez vous."
    >
      <h2>1. Zone de livraison</h2>
      <p>
        BAYO livre actuellement en <strong>{COMPANY.shippingZone}</strong>. Pour toute demande
        d'expédition hors zone, contactez-nous à <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>{" "}
        et nous étudierons les possibilités au cas par cas.
      </p>

      <h2>2. Délais</h2>
      <p>
        Les commandes sont préparées sous <strong>24 à 48 heures ouvrées</strong>. Le délai de
        livraison habituel est de <strong>{COMPANY.shippingDelay}</strong> à compter de l'expédition,
        selon le transporteur choisi et votre localisation.
      </p>
      <p>
        Ces délais sont donnés à titre indicatif et ne tiennent pas compte des éventuels retards
        imputables au transporteur (intempéries, grèves, jours fériés). En cas de retard significatif,
        nous vous tenons informé·e par email.
      </p>

      <h2>3. Transporteurs et frais</h2>
      <p>
        Nous travaillons avec <strong>{COMPANY.shippingPartners}</strong>. Les frais de livraison
        sont calculés en fonction du poids et de la destination, à partir de{" "}
        <strong>{COMPANY.shippingPriceFrom}</strong> pour la France métropolitaine. Le montant exact
        est affiché clairement avant validation du paiement.
      </p>
      <p>
        <strong>Livraison offerte</strong> dès <strong>60 € d'achat</strong> en France métropolitaine
        (hors Corse et DOM-TOM).
      </p>

      <h2>4. Produits numériques</h2>
      <p>
        Les ebooks PDF sont délivrés <strong>instantanément après paiement confirmé</strong>, via :
      </p>
      <ul>
        <li>un email avec le PDF en pièce jointe envoyé à votre adresse de commande,</li>
        <li>un lien de téléchargement permanent dans votre espace client (onglet « Mes commandes »).</li>
      </ul>
      <p>
        Aucun frais de livraison n'est appliqué sur les produits numériques.
      </p>

      <h2>5. Suivi de commande</h2>
      <p>
        Dès l'expédition de votre colis, vous recevez un email contenant un numéro de suivi et un
        lien direct vers le site du transporteur. Vous pouvez également consulter le statut de vos
        commandes dans votre espace client.
      </p>

      <h2>6. Réception du colis</h2>
      <p>
        Nous vous recommandons de vérifier l'état de votre colis à la réception. En cas
        d'avarie ou de produit manquant, formulez des réserves précises et signées auprès du
        livreur, et contactez-nous sous <strong>3 jours</strong> à{" "}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> en joignant des photos.
      </p>

      <h2>7. Adresse de livraison erronée</h2>
      <p>
        Si vous avez saisi une adresse incorrecte, contactez-nous le plus rapidement possible. Si
        votre commande n'a pas encore été expédiée, nous pouvons la modifier. Sinon, les frais de
        réexpédition seront à votre charge.
      </p>
    </LegalLayout>
  );
}
